import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const queryClientSlip = (clientRn, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${PAYMENT_API}/payment/slip/client/${clientRn}?${query}`;
  return backend.get(url);
};

const queryCaregiverSlip = (caregiverRn, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${PAYMENT_API}/payment/slip/caregiver/${caregiverRn}?${query}`;
  return backend.get(url);
};

const markClientSlipCompete = (clientRn, weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/client/${clientRn}/week/${weekOf}/complete`;
  return backend.post(url);
};

const markCaregiverSlipCompete = (caregiverRn, weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/caregiver/${caregiverRn}/week/${weekOf}/complete`;
  return backend.post(url);
};

const queryCompletionClient = (weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/client/completion_status/${weekOf}`;
  return backend.get(url);
};

const queryCompletionCaregiver = (weekOf) => {
  const url = `${PAYMENT_API}/payment/slip/caregiver/completion_status/${weekOf}`;
  return backend.get(url);
};

export default {
  queryClientSlip,
  queryCaregiverSlip,
  markClientSlipCompete,
  markCaregiverSlipCompete,
  queryCompletionClient,
  queryCompletionCaregiver,
};
